<template>
  <section class="success-full">
    <img class="animated zoomIn" src="../../assets/images/success.svg" alt="">
    <h1 class="animated bounceInUp">Thank You!</h1>
    <p class="animated bounceInUp delay-1s">आपका यह टास्क सक्सेस्स्फुल्ली सबमिट हो चुका है। अब आप अगले टास्क को कम्पलीट करे। </p>
    <router-link tag="span" class="btn" :to="{path:'/'}">अगला टास्क देखे</router-link>
    <router-link tag="span" class="text" :to="{path:'/'}">मेरे टास्क</router-link>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </section>
</template>

<script>
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
import { SessionHelper, X_AUTH_ID } from "../../utils/session";
import CustomToaster from "../Common/CustomToaster";

export default {
  name: "UploadedNews",
  components: {},
  computed: {},
  data() {
    return {
        isValidDetail: false,
        toasterData: {},
        loading: false
    };
  },
  methods: {
     goToDashBoard(){
         this.$router.push('/dashboard')
     }
  },
  mounted() {}
};
</script>

<style scoped>
.success-full {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  flex-direction: column;
  text-align: center;
}
.success-full img {
  height: 38vh;
}
.success-full h1 {
  font-size: 4.855vh;
  margin: 32px 0 16px;
}
.success-full p {
  max-width: 310px;
  font-size: 1.1em;
  color: #505050;
  margin-bottom: 16px;
  line-height: 26px;
}
.success-full .btn {
  padding: 12px 20px 10px;
  font-weight: 600;
  font-family: "Kohinoor";
  color: #ff2936;
  border-radius: 25px;
  border: solid 1px #ff2936;
  background-color: #ffffff;
  font-size: 1em;
}
.success-full .text {
  color: #505050;
  font-size: 1em;
  font-weight: 600;
  margin-top: 8px;
}

</style>